import { send } from 'server';

export const sendDepositLimits = limits => send({
    ID: 89904,
    description: 'Set deposit limits',
    responses: [89908, 89900],
    limits
});

export const fetchDepositLimit = () => send({
    ID: 89901,
    responses: [89905, 89900],
    description: 'Get deposit limits'
});

export const declinePlayerDepositLimits = (timePeriod) => send({
    ID: 89902,
    description: 'Accept Player Deposit Limits',
    responses: [89906, 89900],
    action: 'decline',
    timePeriods: timePeriod
});

export const acceptPlayerDepositLimits = (timePeriod) => send({
    ID: 89902,
    description: 'Accept Player Deposit Limits',
    responses: [89906, 89900],
    action: 'accept',
    timePeriods: timePeriod
});
